import { db } from "../Firebase/firebaseconfig";
import {
  collection, addDoc, getDocs, query, updateDoc, doc, where
} from "firebase/firestore";

const COL = "proyectos";

export async function listProyectos() {
  const q = query(
    collection(db, COL),
    where("activo", "==", true)   // si usas borrado suave
  );
  const snap = await getDocs(q);
  return snap.docs
    .map(d => ({ id: d.id, ...d.data() }))
    .sort((a, b) => Number(b.createdAt || 0) - Number(a.createdAt || 0));
}

export async function createProyectoBasico({ nombre }) {
  const ref = await addDoc(collection(db, COL), {
    nombre,
    activo: true,
    createdAt: Date.now(),
  });
  return ref.id;
}

// 🔧 AGREGA ESTAS DOS FUNCIONES:
export async function renameProyecto(id, nuevoNombre) {
  await updateDoc(doc(db, COL, id), {
    nombre: nuevoNombre,
    updatedAt: Date.now(),
  });
}

export async function deleteProyectoSoft(id) {
  await updateDoc(doc(db, COL, id), {
    activo: false,
    deletedAt: Date.now(),
  });
}
